/**NOTE: This is forked version of: https://github.com/trailbehind/lrm-Here/blob/master/src/L.Routing.Here.js */
import * as L from 'leaflet';
import "leaflet-routing-machine";
import * as cors from 'corslite';

export class DPHere {
   private options:any = {
        serviceUrl: 'https://route.ls.hereapi.com/routing/7.2/calculateroute.json',
        timeout: 180 * 1000,
        alternatives: 0,
		mode: 'fastest;car',
		avoidTransportTypes: '',
        urlParameters: {}
    }
    private apiKey:string;
   

    private initialize = () =>{
        L.Util.setOptions(this, this.options);
    }

    getHereRouting(apiKey:string,options?:any) {
        this.apiKey = apiKey;
        const localOptions = { ...this.options }
        this.options = {
            ...localOptions,
            ...options
        }
        L.Routing['Here'] =  L.Class.extend({
                options:this.options,
                intialize: this.initialize,
                route:this.route,
                buildRouteUrl:this.buildRouteUrl
            });
            
        return new L.Routing['Here']();
    }
    route = (waypoints:any,callback:any,context:any,options:any) =>{
        let timedOut = false,
				wps = [],
				url:string,
				timer:any,
				wp:any
			options = options || {};
			url = this.buildRouteUrl(waypoints);

			timer = setTimeout(function() {
								timedOut = true;
								callback.call(context || callback, {
									status: -1,
									message: 'Here request timed out.'
								});
							}, this.options.timeout);

			// Create a copy of the waypoints, since they
			// might otherwise be asynchronously modified while
			// the request is being processed.
			for (let i = 0; i < waypoints.length; i++) {
				wp = waypoints[i];
				wps.push({
					latLng: wp.latLng,
					name: wp.name,
					options: wp.options
				});
			}

			cors(url, (err:any,resp:any) => {
				let data;

				clearTimeout(timer);
				if (!timedOut) {
					if (!err) {
						data = JSON.parse(resp.responseText);
						this.routeDone(data, wps, callback, context);
					} else {
						callback.call(context || callback, {
							status: -1,
							message: 'HTTP request failed: ' + err
						});
					}
				}
			});

			return this;
    }
    buildRouteUrl(waypoints:any) {
        let locs = [],
            alternatives,
            baseUrl:string;
        
        for (let i = 0; i < waypoints.length; i++) {
            locs.push('waypoint' + i + '=geo!' + waypoints[i].latLng.lat + ',' + waypoints[i].latLng.lng);
        }
        if(waypoints.length > 2) {
            alternatives = 0;
        } else {
            //With more than 1 waypoint, requests for alternatives are invalid
            alternatives = this.options.alternatives;
        }
        baseUrl = this.options.serviceUrl + '?' + locs.join('&');
        return baseUrl + L.Util.getParamString(L['extend']({
                instructionFormat: 'text',
                apiKey: this.apiKey,
                representation: "navigation",
				mode: this.options.mode,
                alternatives: alternatives
            }, this.options.urlParameters), baseUrl);
    }
    private routeDone(response:any, inputWaypoints:any, callback:any, context:any){
        let alts = [];

			context = context || callback;
			if (!response.response.route) {
				callback.call(context, {
					status: response.type,
					message: response.details
				});
				return;
			}

			for (let i = 0; i < response.response.route.length; i++) {
				let path = response.response.route[i];
				let coordinates = this.decodeGeometry(path.shape);

				let instructions = [];
				let time = 0;
				let distance = 0;
				for(let j = 0; j < path.leg.length; j++) {
                    let leg = path.leg[j];
                    let instruction = {
                        text: leg.summary.text,
                        distance: leg.summary.distance,
                        time: leg.summary.travelTime,
                        index: j
                    }
                    distance +=  leg.summary.distance;
                    time += leg.summary.travelTime;
                    instructions.push(instruction);
				}

				let waypoints = [];
				for(let p = 0; p< path.waypoint.length; p++) {
					let waypoint = path.waypoint[p];
					waypoints.push(new L.LatLng(
						waypoint.mappedPosition.latitude, 
						waypoint.mappedPosition.longitude));
				}
				alts.push({
					name: '',
					coordinates: coordinates,
					instructions: instructions,
					summary: {
						totalDistance: distance,
						totalTime: time,
					},
					inputWaypoints: inputWaypoints,
					waypoints: waypoints
				});
			}

			callback.call(context, null, alts);
    }
    private decodeGeometry(geometry:any) {
        var latlngs = new Array(geometry.length),
            coord;
        for (let i = 0; i < geometry.length; i++) {
            coord = geometry[i].split(",");
            latlngs[i] = ([parseFloat(coord[0]), parseFloat(coord[1])]);
        }

        return latlngs;
    }
    
}
